import { ChartEmptyState } from "src/components/charts/chart-empty-state";
import { LineChartLoader } from "src/components/charts/loaders";
import { MediaDetailSection } from "src/components/media-detail";
import { FatigueCurveChart } from "src/pages/ad-studio/insights/fatigue-curve-chart";
import { FailureAlert } from "src/pages/ad-studio/insights/performance/failure-alert";
import type {
  DailyPoint,
  DailySeries,
  InsightsFailure,
  InsightsQueryResult,
  Reported,
} from "src/pages/ad-studio/insights/performance/types";

type AdDailyChartProps = {
  daily: InsightsQueryResult<DailySeries, InsightsFailure>;
};

// Recharts reads a gap in a series as null.
const toChartValue = (value: Reported): number | null =>
  value === "not-reported" ? null : value;

const toCurvePoint = ({ date, ctr, frequency }: DailyPoint) => ({
  date,
  ctr: toChartValue(ctr),
  frequency: toChartValue(frequency),
});

export const AdDailyChart = ({ daily }: AdDailyChartProps) => {
  switch (daily.status) {
    case "loading": {
      return <LineChartLoader />;
    }
    case "failed": {
      return <FailureAlert failure={daily.failure} />;
    }
    case "loaded": {
      const { points, labels } = daily.value;
      return (
        <MediaDetailSection title="Fatigue curve">
          {points.length === 0 ? (
            <ChartEmptyState
              message="No daily performance to display"
              height={56}
            />
          ) : (
            <FatigueCurveChart
              data={points.map(toCurvePoint)}
              labels={labels}
              height={220}
            />
          )}
        </MediaDetailSection>
      );
    }
    default: {
      return daily satisfies never;
    }
  }
};
